import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=71b76814&scoped=true"
import script from "./addPosition.vue?vue&type=script&lang=js"
export * from "./addPosition.vue?vue&type=script&lang=js"
import style1 from "./addPosition.vue?vue&type=style&index=1&id=71b76814&prod&lang=less&scoped=true"
import style2 from "./addPosition.vue?vue&type=style&index=2&id=71b76814&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b76814",
  null
  
)

export default component.exports